import { render } from "./photosCard.vue?vue&type=template&id=1e8f4f7e&scoped=true"
import script from "./photosCard.vue?vue&type=script&lang=js"
export * from "./photosCard.vue?vue&type=script&lang=js"

import "./photosCard.vue?vue&type=style&index=0&id=1e8f4f7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8f4f7e"]])

export default __exports__